function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { logger as N } from "../../shared-lib/index.js";
export function getByteLength(t) {
  var e = t.length;

  for (var n = t.length - 1; n >= 0; n--) {
    var r = t.charCodeAt(n);
    r > 127 && r <= 2047 ? e++ : r > 2047 && r <= 65535 && (e += 2), r >= 56320 && r <= 57343 && n--;
  }

  return e;
}
export function decodeBrazeActions(t) {
  try {
    t = t.replace(/-/g, "+").replace(/_/g, "/");
    var e = window.atob(t),
        n = new Uint8Array(e.length);

    for (var _t = 0; _t < e.length; _t++) {
      n[_t] = e.charCodeAt(_t);
    }

    var r = new Uint16Array(n.buffer);
    return String.fromCharCode.apply(String, _toConsumableArray(r));
  } catch (t) {
    return N.error("Unable to decode Base64: " + t), null;
  }
}